import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as mediaActions from '../store/media/actions';
import * as listsActions from '../store/lists/actions';
import * as adsActions from '../store/ads/actions';
import * as reducers from '../store/reducers';

import ContentCollections from 'Containers/ContentCollections';
import ContentCanvas from 'Components/ContentCanvas';
import ContentHeader from 'Components/ContentHeader';
import ContentInfoBox from 'Components/ContentInfoBox';
import GameControls from 'Components/GameControls';
import GameOverAd from 'Components/GameOverAd';
import ContentTags from 'Components/ContentTags';
import ErrorPage from 'Screens/ErrorPage';
import Loading from 'Components/Loading';
import RampUnit from '../utils/Playwire/RampUnit';

import DocumentHeadFields from 'Components/DocumentHeadFields';
import VideoSiderailPlayer from 'Components/VideoSiderailPlayer';

import { withLocationWrapper } from '../utils/HOC_LocationWrapper';


class GamePage extends Component {
  constructor(props) {
    super(props);
    this.setAdTargeting = this.setAdTargeting.bind(this);
    this.onSponsoredGameLoad = this.onSponsoredGameLoad.bind(this);
    this.startGameHandler = this.startGameHandler.bind(this);
    this.state = {
      adTargeting: this.setAdTargeting(props),
      pageLoading: true,
    };
  }

  setAdTargeting(props) {
    const { params, location, game } = props;
    let targeting = {
      section: `gamePermalink`,
      contentType: 'game',
      contentId: params.gameID,
    };

    if (game) {
      const { tags, title, gradeRange } = game;
      const grades = [];
      for (let x = gradeRange.lower; x <= gradeRange.higher; x++)
        grades.push(x);
      targeting = {
        ...targeting,
        contentTags: tags,
        contentTitle: title,
        grades,
      };
    }
    // This allows SBX media to test ad units.
    if (location.query?.clienttest) {
      targeting['clienttest'] = location.query.clienttest;
    }
    return targeting;
  }

  onSponsoredGameLoad() {
    const { trackAdInternal, gamePageHeroAdCampaign } = this.props;
    trackAdInternal(
      'gamePage',
      'SPONSORED_CONTENT_VIEWED',
      gamePageHeroAdCampaign
    );
  }

  componentDidMount() {
    this.fetchData();
    if (
      typeof this.props.gamePageHeroAdCampaign !== 'undefined' &&
      this.props.gamePageHeroAdCampaign.customGameSlug === this.props.slug
    )
      this.onSponsoredGameLoad();
  }

  componentDidUpdate(prevProps) {
    if (this.props.slug !== prevProps.slug) {
      this.fetchData();
      this.setState({
        pageLoading: true,
      });
    }
    if (this.props.game !== prevProps.game) {
      this.setState({
        adTargeting: this.setAdTargeting(this.props),
        pageLoading: false,
      });
    }
    if (!this.props.isFetching && this.state.pageLoading) {
      this.setState({
        pageLoading: false,
      });
    }
  }


  fetchData() {
    const { slug, fetchMedia, fetchMediaLists, location } = this.props;
    fetchMedia(slug);
    const qs = { slug };
    fetchMediaLists('gamePermalink', location.pathname, qs);
  }

  startGameHandler(slug) {
    this.props.onStartGame(slug);
  }

  render() {
    const {
      game,
      lists,
      isListsFetching,
      errors,
      onEndGame,
      onReplayGame,
      onGameRestart,
      closeGameOverAd,
    } = this.props;

    const { adTargeting, pageLoading } = this.state;

    if ((errors.media || errors.lists) && !game) {
      const message = errors.media.message || errors.lists.message;
      return (
        <ErrorPage
          errorCode="404"
          errorType="pageNotFound"
          errorMessage={message}
        />
      );
    }
    if (pageLoading || !game) {
      return <Loading />;
    }
    return (
      <React.Fragment>
        <main>
          {game ? <DocumentHeadFields mediaItem={game} /> : null}
          <div className="Page__container Page__container--no-padding">
            <RampUnit type="leaderboard_atf" id="top" />
          </div>

          <div className="Page__ContentWrapper">
            <div className="Page__container Page__container--split-layout Page__container--main">
              <section className="ContentBlock ContentBlock--content-canvas">
                <div className="ContentBlock__content">
                  <ContentHeader {...game} />
                  <ContentCanvas
                    {...game}
                    showPreContentAd={true}
                    gameStarted={game.isStarted}
                    onStartGame={() => this.startGameHandler(game.slug)}
                    onEndGame={gameData => onEndGame(game.slug, gameData)}
                    onReplayGame={() => onReplayGame(game.slug)}
                    onGameRestart={() => onGameRestart(game.slug)}
                    maxWidth={game.slug === 'poptropica' ? '960px' : null}
                  />
                  <div className="Page__item-details">
                    <ContentInfoBox
                      headline="How to Play"
                      body={game.gameObjective}
                      extraClass=" ContentInfoBox--GameObjective"
                    />
                    <GameControls {...game} />
                    <ContentTags {...game} />
                  </div>
                  {game.slug !== 'poptropica' ? (
                    <aside className="ContentBlock__aside">
                      <RampUnit type="med_rect_atf" id="siderec" />
                      <RampUnit type="med_rect_btf" id="sideflex" />
                    </aside>
                  ) : null}
                  {!isListsFetching ? (
                    <ContentCollections lists={lists} />
                  ) : null}
                </div>
              </section>
            </div>
          </div>
        </main>
        {game.displayGameOverAd && (
          <GameOverAd
            targeting={adTargeting}
            clickHandler={() => closeGameOverAd(game.slug)}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, { params, location }) => {
  const slug = params.gameID;
  return {
    slug,
    isFetching: reducers.getIsPageFetching(state),
    game: reducers.getMediaItem(state, slug),
    gamePageHeroAdCampaign: reducers.getAdCampaign(state, 'gamePageHero'),
    lists: reducers.getMediaLists(state, 'gamePermalink', location.pathname),
    errors: reducers.getErrors(state),
  };
};

const allActions = {
  ...mediaActions,
  ...listsActions,
  ...adsActions,
};

const GamePageComponent = connect(mapStateToProps, allActions)(GamePage);

export default withLocationWrapper(GamePageComponent);
